import { render, staticRenderFns } from "./FieldValue.vue?vue&type=template&id=3db60378&scoped=true&"
import script from "./FieldValue.vue?vue&type=script&lang=js&"
export * from "./FieldValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db60378",
  null
  
)

export default component.exports